import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

function Scheme() {
  const [schemeName, setSchemeName] = useState("");
  const [status, setStatus] = useState("active");
  const [schemes, setSchemes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSchemes = async () => {
    try {
      // const res = await fetch("http://127.0.0.1:6060/api/v1/scheme/list", {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      const res = await authFetch("/api/v1/scheme/list");
      if (!res) return;
      const data = await res.json();
      if (Array.isArray(data)) setSchemes(data);
      else setSchemes([]);
    } catch (err) {
      showToast("Failed to fetch schemes", "error");
    }
  };

  useEffect(() => {
    fetchSchemes();
  }, []);

  const showToast = (message, type = "success") => {
    if (window.toastr) {
      toastr.options = {
        closeButton: true,
        progressBar: true,
        positionClass: "toast-top-right",
        timeOut: "3000",
      };
      toastr[type](message);
    }
  };

  const handleCreateOrUpdateScheme = async () => {
    if (!schemeName.trim()) {
      showToast("Scheme name is required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/scheme/update"
      : "/api/v1/scheme/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
        body: JSON.stringify({
          id: editingId,
          name: schemeName,
          status,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "Scheme updated" : "Scheme created", editingId ? "info" : "success");

      setSchemeName("");
      setEditingId(null);
      fetchSchemes();

      // Close modal
      document.querySelector("#exampleModal .btn-close").click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (scheme) => {
    setSchemeName(scheme.name);
    setStatus(scheme.status || "active");
    setEditingId(scheme.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this scheme?")) return;

    try {
      // const res = await fetch(`http://127.0.0.1:6060/api/v1/scheme/delete/${id}`, {
      //   method: "DELETE",
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      const res = await authFetch(`/api/v1/scheme/delete/${id}`, { method: "DELETE" });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("Scheme deleted", "error");
      fetchSchemes();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  useEffect(() => {
    if (schemes.length === 0) return;
  
    const $ = window.$;
    const interval = setInterval(() => {
      const table = $("#example2");
      if (!table.length || !$.fn.DataTable) return;
  
      try {
        if ($.fn.DataTable.isDataTable(table)) {
          table.DataTable().destroy();
        }
  
        const dt = table.DataTable({
          lengthChange: false,
          pageLength: 10,
          // buttons: ["copy", "excel", "pdf", "print", "colvis"],
          order: [[0, "desc"]], // disable initial ordering
        });
  
        dt.buttons().container().appendTo("#example2_wrapper .col-md-6:eq(0)");
        clearInterval(interval);
      } catch (err) {
        console.error("DataTable init error:", err);
      }
    }, 100);
  
    return () => clearInterval(interval);
  }, [schemes]);

  return (
    <>
      <div className="page-wrapper">
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">Scheme Manager</h4>
                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => {
                      setSchemeName("");
                      setEditingId(null);
                    }}
                  >
                    Add
                  </button>
                </div>

                {/* Modal */}
                <div
                  className="modal fade"
                  id="exampleModal"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          {editingId ? "Edit Scheme" : "Add Scheme"}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <input
                          className="form-control"
                          placeholder="Enter Scheme Name"
                          value={schemeName}
                          onChange={(e) => setSchemeName(e.target.value)}
                        />
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateOrUpdateScheme}
                          disabled={loading}
                        >
                          {loading
                            ? "Saving..."
                            : editingId
                            ? "Update"
                            : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <hr />
                <div className="table-responsive">
                  <table id="example2" className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Scheme Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                        <th>Setting</th>
                      </tr>
                    </thead>
                    <tbody>
                      {schemes.length === 0 && (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No schemes found
                          </td>
                        </tr>
                      )}
                      {schemes.map((scheme,i) => (
                        <tr key={scheme.id}>
                          <td>{i + 1}</td> 
                          <td>{scheme.name}</td>
                          <td>{scheme.status}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              onClick={() => handleEdit(scheme)}
                            >
                             <span className="bx bx-edit"></span>
                            </button>
                            <button
                              className="btn btn-sm btn-danger d-none"
                              onClick={() => handleDelete(scheme.id)}
                            >
                             <span className="bx bx-trash"></span>
                            </button>
                          </td>
                          <td>
                            {/* <button type="button" class="btn btn-dark m-1 px-5"><i class="bx bx bx-rupee me-1"></i>Commission</button> */}
                          <Link to={`/CommissionSlab/${scheme.id}`} className="btn btn-dark m-1 px-5">
                            <i className="bx bx-rupee me-1"></i>Commission
                          </Link>
                          {/* <Link to={`/commission/${scheme.id}`} className="btn btn-dark m-1 px-5">
                            <i className="bx bx-rupee me-1"></i>Commission
                          </Link> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </>
  );
}

export default Scheme;
